export default {
  default: () => import("/Users/amin/Documents/Work/HHAA/Projects/game/taline-shell-game/layouts/default.vue").then(m => m.default || m)
}